import type { Icon as PhosphorIcon } from "@phosphor-icons/react"

interface MasonryHoverOverlayProps {
  icon: PhosphorIcon
  productName: string
  widgetName: string
  description: string
}

export function MasonryContent({
  icon: Icon,
  productName,
  widgetName,
  description,
}: MasonryHoverOverlayProps) {
  return (
    <div className="relative">
      <div className="flex items-center justify-center w-10 h-10 rounded-lg border border-solid border-border-default mb-4">
        <Icon className="w-5 h-5 text-fg-default" weight="regular" />
      </div>

      <span className="text-xs font-mono uppercase tracking-wider text-fg-secondary mb-1">
        {productName}
      </span>

      <h4 className="text-xl font-medium tracking-tight text-fg-default mb-3">
        {widgetName}
      </h4>

      <p className="text-sm text-fg-secondary leading-relaxed max-w-[350px] text-balance">
        {description}
      </p>
    </div>
  )
}
